import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idToUnit',
})
export class IdToUnitPipe implements PipeTransform {
  transform(value: any, units: any[]): String {
    if (units) {
      let unit = units.find((unit) => unit.id === value);
      if (unit) return unit.si_unit;
      else return 'Unknown unit';
    }
    return 'Cannot find unit';
  }
}
